import { Group, Stack, Text } from '@mantine/core';
import React from 'react';
import Badge from '../../components/elements/Badge';
import LabelDate from '../../components/fragments/LabelDate';
import Button from '../../components/elements/Button';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelVoucher, pickVoucher } from '../../services/detailRedeem';
import { showNotification } from '../../utilities/mantineNotification';
import { useHistory, useLocation } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import ModalRedeem from './ModalRedeem';

function useGetQuery() {
  const { search } = useLocation();
  // history

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ActionVoucherRedeem = ({ dataDetail }) => {
  let query = useGetQuery();
  let history = useHistory();
  let queryClient = useQueryClient();
  const [opened, { toggle }] = useDisclosure(false);

  const voucherCancel = useMutation({
    mutationFn: cancelVoucher,
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [
          'getDetailRedeem',
          query.get('type').toString(),
          dataDetail?.id
        ]
      });
      showNotification({
        type: 'success',
        title: 'Success Cancel Redeem'
      });
      history.goBack();
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const redeemVoucher = useMutation({
    mutationFn: pickVoucher,
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [
          'getDetailRedeem',
          query.get('type').toString(),
          dataDetail?.id
        ]
      });
      showNotification({
        type: 'success',
        title: 'Success Redeem Voucher'
      });
      history.goBack();
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleCancelVoucher = () => {
    const payload = {
      inventoryRewardPickedID: query.get('type').toString()
    };
    voucherCancel.mutate(payload);
  };

  const handleAction = () => {
    if (dataDetail?.isPicked === 'Diambil') {
      handleCancelVoucher();
    }
    if (parseInt(dataDetail?.point) > parseInt(dataDetail?.redeemPoint)) {
      if (dataDetail?.maxRedeem === dataDetail?.totalRedeemed) {
        return null;
      }

      if (dataDetail?.availableStock === 0) {
        return null;
      }
    }
    toggle();
  };

  const handleRedeem = () => {
    const payload = {
      inventoryRewardID: dataDetail.inventoryRewardID,
      inventoryRewardPickedID: null,
      status: 'Diambil'
    };
    redeemVoucher.mutate(payload);
  };

  const buttonStatus = () => {
    if (dataDetail?.isPicked === 'Diambil') {
      return { variant: 'error', text: 'Cancel Redeem', disabled: false };
    }
    if (parseInt(dataDetail?.point) > parseInt(dataDetail?.redeemPoint)) {
      if (dataDetail?.maxRedeem === dataDetail?.totalRedeemed) {
        return {
          variant: 'solid',
          text: `You already redeem ${dataDetail?.maxRedeem} times!`,
          disabled: true
        };
      }
      if (dataDetail?.availableStock === 0) {
        return { variant: null, text: 'Stock is Empty', disabled: true };
      }
      return { variant: 'solid', text: 'Redeem Voucher', disabled: false };
    }
    return { variant: null, text: 'Not Enough Point', disabled: true };
  };

  if (
    dataDetail?.statusVoucher !== 'Diambil' &&
    dataDetail?.statusVoucher !== 'Kosong'
  ) {
    const detailStatus = () => {
      switch (dataDetail?.statusVoucher) {
        case 'Approved':
          return { color: 'green', text: 'Approved' };
        case 'Rejected':
          return { color: 'red', text: 'Rejected' };
        default:
          return { color: 'yellow', text: 'Waiting for Approval' };
      }
    };

    return (
      <Stack gap={8}>
        <Badge variant="light" color={detailStatus().color}>
          {detailStatus().text}
        </Badge>
        <Text className="text-sm-medium">
          Updated at:{' '}
          <Text span inherit className="text-sm-semibold">
            <LabelDate date={dataDetail?.dateUp} />
          </Text>
        </Text>
        <Group gap={4}>
          <Text className="text-sm-semibold">Note:</Text>
          <Text className="text-sm-medium" style={{ whiteSpace: 'pre-line' }}>
            {dataDetail?.notes || '-'}
          </Text>
        </Group>
      </Stack>
    );
  }

  return (
    <>
      <Button
        onClick={handleAction}
        variant={buttonStatus().variant as any}
        disabled={buttonStatus().disabled}
      >
        {buttonStatus().text}
      </Button>

      <ModalRedeem
        opened={opened}
        onClose={toggle}
        onRedeem={handleRedeem}
        voucherName={dataDetail?.inventoryName}
      />
    </>
  );
};

export default ActionVoucherRedeem;
